import { render, staticRenderFns } from "./DeleteSelectedModalDialog.vue?vue&type=template&id=12e283b6&"
import script from "./DeleteSelectedModalDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteSelectedModalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports